import React, { useEffect, useState } from "react";
import { View, Text, Image as RNImage, Platform } from "react-native";
import ProfileDetails from "./Profiles/ProfileDetails";
import ProfileEditForm from "./Profiles/ProfileEditForm";

/**
 * Helper to upload a new profile image to API.
 * Returns new profile image ID if success.
 */

const fetchClientProfile = async () => {
  const resp = await window.main.axios.get(window.main.api.getClientProfile);
  console.log("fetchClientProfile result:", resp.data);
  if (resp?.data?.staff_id) {
    window.main.lib.setUserProfile(resp.data);
    return resp.data;
  }
  return null;
};

const Profile = () => {
  const _theme = window.main.theme;

  // Add version state
  const [profileVersion, setProfileVersion] = useState(0);

  const [userProfileOrig, setUserProfile] = useState(window.main.lib.getUserProfile());

  // Use the latest data from userProfile
  //const userProfileOrig = window.main.lib.getUserProfile();
  const [form, setForm] = useState({
    first_name: userProfileOrig.first_name || "",
    last_name: userProfileOrig.last_name || "",
    email: userProfileOrig.email || "",
    phone_1: String(userProfileOrig.phone_1 || "").replace(/\D/g, "").slice(0, 10),
  });

  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    const refreshed = window.main.lib.getUserProfile();

    setUserProfile(refreshed);
    setErrors({});
    setForm({
      first_name: refreshed.first_name || "",
      last_name: refreshed.last_name || "",
      email: refreshed.email || "",
      phone_1: String(refreshed.phone_1 || "").replace(/\D/g, "").slice(0, 10),
    });

  }, [profileVersion]);

  // This is called after a successful profile update or image upload
  const refreshProfile = async () => {
    const updated = await fetchClientProfile();
    setProfileVersion(v => v + 1);

    if (updated) {
      setForm({
        first_name: updated.first_name || "",
        last_name: updated.last_name || "",
        email: updated.email || "",
        phone_1: String(updated.phone_1 || "").replace(/\D/g, "").slice(0, 10),
      });
      setUserProfile(updated);
    }
  };

  const handleStartEdit = () =>  setEditing(true);
  //const handleChange = (field, value) => setForm((old) => ({ ...old, [field]: value }));
  const handleChange = (field, value) => {setForm((old) => ({ ...old, [field]: value }));setErrors((old) => ({ ...old, [field]: null }));};
  //const handleCancel = () => setEditing(false);
  const handleCancel = () => {setErrors({});setEditing(false);};

  const handleSubmit = async (payload) => {
    window.main.lib.setStatusState(null);

    const cleanedPhone = String(payload.phone_1 || "").replace(/\D/g, "").slice(0, 10);

    const nextErrors = {};

    if (!String(payload.first_name || "").trim()) {
      nextErrors.first_name = "First name is required.";
    }

    if (!String(payload.last_name || "").trim()) {
      nextErrors.last_name = "Last name is required.";
    }

    if (!String(payload.email || "").trim()) {
      nextErrors.email = "Email is required.";
    } else if (!window.main.lib.isValidEmail(payload.email)) {
      nextErrors.email = "Enter a valid email address.";
    }

    if (!cleanedPhone) {
      nextErrors.phone_1 = "Phone is required.";
    } else if (cleanedPhone.length !== 10) {
      nextErrors.phone_1 = "Phone must have 10 digits.";
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      window.main.lib.setStatusState("Please fix the highlighted fields.");
      return;
    }

    setErrors({});

    const cleanedPayload = {
      ...payload,
      phone_1: cleanedPhone,
    };

    setLoading(true);
    try {
      window.main.lib.setLoadingState(true);
      const result = await window.main.axios.post(
        window.main.api.updateClientProfile,
        cleanedPayload
      );

      if (result.data?.success) {
        await refreshProfile();
        setEditing(false);
        window.main.lib.setStatusState("Profile updated.");
      } else {
        window.main.lib.setStatusState(result.data?.error || "Failed to update profile.");
      }
    } catch (err) {
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      setLoading(false);
      window.main.lib.setLoadingState(false);
    }
  };

  // Always uses latest state!
  // const displayedImageUrl = pendingImageUrl || profileImageUrl;
  const userProfile = {...userProfileOrig};

  return (
    <View style={{alignItems:"flex-start",display:"flex",flexDirection:"column",justifyContent:"flex-start",paddingHorizontal:24,paddingTop:30,width:"100%"}}>
      <View style={{width:"100%",maxWidth:325}}>
        <View style={{ marginBottom: 15 }}>
          <Text style={{ ..._theme.pageTitleText, fontWeight: "bold", marginBottom: 0 }}>
            My Profile
          </Text>
        </View>
        <View style={{..._theme.containerLiner,alignSelf: "stretch",backgroundColor:_theme.colors.mode.containerBackgroundColor,borderRadius:_theme.borderRadius,marginBottom:30,marginHorizontal:0,marginLeft:0,marginRight:0,minWidth:300,padding:24,position:"relative",width:"100%"}}>
          {editing ? (
            <ProfileEditForm form={form} errors={errors} onChange={handleChange} onCancel={handleCancel} onSubmit={handleSubmit} profile={userProfile} theme={_theme} loading={loading} />
          ) : (
            <ProfileDetails profile={userProfile} onEdit={handleStartEdit} theme={_theme} />
          )}
        </View>
      </View>
    </View>
  );
};

export default Profile;